import { Link } from 'react-router-dom';
import type { Movie } from '@/types';

interface MovieListItemProps {
  movie: Movie;
}

export default function MovieListItem({ movie }: MovieListItemProps) {
  return (
    <article className="flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200/70 bg-background-100 p-4 transition-all duration-300 hover:border-primary-300 sm:flex-row md:p-5">
      <Link
        to={`/detail/${movie.id}`}
        className="relative h-44 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-44 sm:w-32 cursor-pointer"
      >
        <img
          src={movie.poster}
          alt={`${movie.title} 影视海报`}
          title={`${movie.title} 剧情介绍与角色`}
          className="h-full w-full object-top"
        />
      </Link>

      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex flex-wrap items-center gap-2">
          <Link to={`/detail/${movie.id}`} className="font-heading text-lg font-bold text-foreground-950 hover:text-primary-700 cursor-pointer">
            {movie.title}
          </Link>
          <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">{movie.category}</span>
          <span className="flex items-center gap-1 rounded bg-accent-100 px-2 py-0.5 text-[11px] text-accent-800">
            <i className="ri-star-fill text-[10px]"></i>{movie.rating.toFixed(1)}
          </span>
        </div>
        <p className="mt-1.5 text-xs text-foreground-500">{movie.subtitle}</p>
        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-foreground-600">
          <span className="flex items-center gap-1"><i className="ri-user-star-line"></i> 主演 · {movie.cast.join(' / ')}</span>
          <span className="flex items-center gap-1"><i className="ri-calendar-line"></i> {movie.year}</span>
          <span className="flex items-center gap-1"><i className="ri-earth-line"></i> {movie.region}</span>
        </div>
        <p className="mt-3 text-sm leading-7 text-foreground-600 line-clamp-2">{movie.synopsis}</p>
        <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
          <div className="flex flex-wrap gap-1.5">
            {movie.genres.map((g) => (
              <span key={g} className="rounded-full bg-background-200/70 px-2.5 py-0.5 text-[11px] text-foreground-700">{g}</span>
            ))}
          </div>
          <Link
            to={`/detail/${movie.id}`}
            className="inline-flex items-center gap-1 rounded-md bg-primary-500 px-4 py-2 font-label text-xs text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
          >
            查看详情 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}